import { z } from "zod";

export const storeContactTypeSchema = z.enum([
  "PHONE",
  "LINE",
  "FACEBOOK",
  "INSTAGRAM",
  "EMAIL",
  "WEBSITE",
  "OTHER",
]);

export const createStoreContactSchema = z.object({
  contactType: storeContactTypeSchema,
  contactValue: z.string().trim().min(1).max(500),
  label: z.string().trim().max(100).optional(),
  isPrimary: z.boolean().optional(),
  isPublic: z.boolean().optional(),
});
export type CreateStoreContactInput = z.infer<typeof createStoreContactSchema>;

export const updateStoreContactSchema = createStoreContactSchema.partial();
export type UpdateStoreContactInput = z.infer<typeof updateStoreContactSchema>;
